export default __webpack_public_path__ + "static/media/banner-page-iadi-mobile.b21e073c.png";